import { forwardRef, type InputHTMLAttributes } from 'react'

import styles from './Input.module.css'

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ id, label, ...props }, ref) => (
    <label className={styles.field} htmlFor={id}>
      <span className={styles.label}>{label}</span>
      <input ref={ref} id={id} className={styles.input} {...props} />
    </label>
  )
)

Input.displayName = 'Input'
